import { ControlWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-label-widget',
  templateUrl: './label.widget.html'
})
export class MyLabelWidgetComponent extends ControlWidget {

}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/label/label.widget.ts